import { axios, Globals } from 'utils';
import { AxiosResponse } from 'axios';

class Api {
  createResponse = (uri: string, params?: any) => {
    if (!params) {
      params = {};
    }
    return new Promise((resolve, reject) => {
      if (!params.withoutLoading) {
        Globals.setLoading();
      }
      // `hasFile`/`withoutLoading`/`withoutError` son señales internas para
      // este helper (qué método de axios usar, si mostrar loading/error) --
      // nunca deben viajar como campo del request. `axios.upload()` mete
      // TODAS las llaves del objeto al FormData tal cual (ver createFormData
      // en utils/axios.ts), así que sin este strip terminaban llegando al
      // backend como campos sueltos del body.
      const { hasFile, withoutLoading, withoutError, ...body } = params;
      axios[hasFile ? 'upload' : 'post'](uri, body)
        .then((res: AxiosResponse) => {
          if (!params.withoutLoading) {
            Globals.quitLoading();
          }
          resolve(res.data);
        })
        .catch((err: any) => {
          if (!params.withoutLoading) {
            Globals.quitLoading();
          }
          // err.friendlyMessage ya viene normalizado desde el interceptor de axios.ts.
          // Un único punto de muestra de error — nunca más doble modal ni [Object object].
          if (!params.withoutError) {
            Globals.showError(err.friendlyMessage);
          }
          reject(err);
        });
    });
  };
}

export default new Api();
